// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { dealerDetailsPageStyles } from "@stoneage/Overrides/Pages/DealerDetailsPage";
import { css } from "styled-components";
import { color, xScreen } from "@stoneage/XDL/Utilities";

dealerDetailsPageStyles.container = {
    gap: 0,
    css: css`
        border: 1px solid ${color("common.border")};
        margin-bottom: 96px;
    `,
};

dealerDetailsPageStyles.infoGridItem = {
    width: [12, 12, 12, 4, 4],
};

dealerDetailsPageStyles.mapGridItem = {
    width: [12, 12, 12, 8, 8],
    css: css`
        border-left: 1px solid ${color("common.border")};
        ${xScreen("lte", "sm")} {
            border-top: 1px solid ${color("common.border")};
            border-left: 0;
        }
    `,
};
